import { useCallback } from 'react'
import { useControlStore, useModelStore } from '@editorStores'

/**
 * Returns a setter for the "compact" model column that also hides the element types whose
 * storey-controls toggles disappear in compact mode (and restores them when leaving compact).
 * Use this everywhere compact is toggled — the header button as well as the IFC-import auto-apply —
 * so the scene never keeps showing elements the user can no longer toggle.
 */
const useSetModelColumnCompact = (): ((compact: boolean) => void) => {
  const setModelColumnCompact = useControlStore(state => state.setModelColumnCompact)
  const setCompactTypesHidden = useModelStore(state => state.setCompactTypesHidden)

  return useCallback(
    (compact: boolean) => {
      setModelColumnCompact(compact)
      setCompactTypesHidden(compact)
    },
    [setModelColumnCompact, setCompactTypesHidden],
  )
}

export default useSetModelColumnCompact
